import {getAudioForSource} from "../../../../../common/utils/audioUtils";
import {DutchNoun, DutchNounResources} from "../types";
import {StyledTable} from "../../../../../common/components/StyledTable";
import {GeneralWordResources} from "../../../../../common/types/words";
import {Box} from "@mui/material";

export interface DutchNounConjugationViewProps {
    nounMorphology: DutchNoun;
    nounResources: GeneralWordResources<DutchNounResources> | null;
}


export function DutchNounConjugationView({nounMorphology, nounResources}: DutchNounConjugationViewProps) {

    const handleCellClicked = (row: { resource: string | null | undefined }, cellIndex: number) => {
        if (cellIndex !== 1) return;
        getAudioForSource(row.resource)?.play();
    };

    return (
        <Box mt={1}>
            <StyledTable
                columns={[
                    {key: "key", render: (row) => row.field, clickable: false},
                    {key: "value", render: (row) => row.value},
                ]}
                rows={[{field: "Plural", value: `de ${nounMorphology.plural}`, resource: nounResources?.plural}]}
                getRowKey={() => 0}
                showHeader={false}
                onCellClicked={handleCellClicked}
            />
        </Box>
    )


}
